









































































































// import ProjectCreationContainer from "./project/ProjectCreationContainer";
import { Component, Vue } from 'vue-property-decorator';

import { projectStore, store, userStore } from '@/store/store';
// import {RecursiveFolder} from '@components/Projects/RecursiveFolder.vue';
import { IProjectMetadata, IR23ReportMetadata } from '@/interfaces/report';
import { dateDisplayBasic, dateTimeDisplay } from '@/lib/util/dateFunctions';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';

@Component({
  name: 'Projects',
  components: {
    PxTextEntryBox,
    PxTextArea,
  },
})
export default class Projects extends Vue {
  // Data
  // user = userManager.user;
  userSelectedFolder: string | null = null;

  newParentFolder: object | null = null;

  newFolderName: string | null = null;

  showDeleteProjectModal: boolean = false;

  displayLegacyReports: boolean = false;

  // Size of icons in actions menu
  iconSize = 'lg';

  // Table sorting
  sortBy = 'modified';

  sortDesc = true;

  // Fields displayed in table of available projects
  projectTableFields: { key: string, sortable: boolean, label?: string }[] = [
    { key: 'name', sortable: true },
    { key: 'created', sortable: true },
    { key: 'modified', sortable: true, label: 'Last Modified' },
    { key: 'total_scenarios', sortable: true, label: 'Scenarios' },
    { key: 'actions', sortable: false },
  ];

  projectNewFolderId: string | null = null;

  projectToEdit: IR23ReportMetadata | null = null;

  store = store;

  get projectsInActiveFolder(): IProjectMetadata[] {
    return this.availableProjects;
  }

  availableProjects: IProjectMetadata[] = [];

  loadAvailableProjects() {
    projectStore.loadAvailableProjects().then((projects) => this.availableProjects = JSON.parse(JSON.stringify(projects)));
  }

  dateDisplay(isoString: string): string {
    return dateDisplayBasic(isoString);
  }

  dateTimeDisplay(isoString: string): string {
    return dateTimeDisplay(isoString);
  }

  numScenarios(project: IProjectMetadata) {
    return (project.asphaltScenarios ? project.asphaltScenarios.length : 0)
      + (project.concreteScenarios ? project.concreteScenarios.length : 0)
      + (project.porousScenarios ? project.porousScenarios.length : 0)
      + (project.acOverlayScenarios ? project.acOverlayScenarios.length : 0)
      + (project.lccaScenarios ? project.lccaScenarios.length : 0);
  }

  migrationProgressPct = 0;

  /*
  Project CRUD operations
  */


  getFullProject(projectId: number): void {
    console.log('Starting project fetch for', projectId);
    // return store.dispatch('rx/getFullProject', id)
  }
  
  setCurrentProject(id: number) {
    projectStore.setProjectId(id);
  }

  copyThisProject(projectId: number): void {
    console.log('Copy project', projectId);
    // store.dispatch('rx/copyProject', id).then(() => store.dispatch('rx/getAvailableProjects'))
  }

  openDeleteProjectModal(projectId: number): void {
    // const project = this.getFullProject(id);
    const project = this.projectsInActiveFolder.filter((p) => p.id === projectId)[0];
    this.$bvModal.msgBoxConfirm(`Are you sure you want to delete the project ${project.name}? PxProjectId:${projectId}`)
      .then((value) => {
        if (value === true) {
          projectStore.deleteProject(projectId).then((result) => {
            if (result !== null) {
              // Remove it from the display without a full page reload
              this.availableProjects = this.availableProjects.filter((p) => p.id !== projectId);
            }
          });
        }
      });
  }


  /*
  Folder CRUD operations
  */

  openChangeFolderModal(projectId: number): void {
    console.log('Changing folder for project ', projectId);
    // this.getFullProject(id).then( result => {
    //   console.log('result', result);
    //   this.$bvModal.show('changeFolderModal')
    // });
  }

  saveFolderChange(projectId: number, folderId: number): void {
    console.log('Saving folder change', projectId, folderId);
    //   // Load project into Vuex
    //   this.getFullProject(id).then(() => {
    //     // Set folder
    //     this.currentProject.folder = folderId;
    //
    //     // Save
    //     store.dispatch('rx/saveProject').then(() => {
    //       store.dispatch('rx/getAvailableProjects')
    //     })
    //   });
    //
    //   this.$bvModal.hide('changeFolderModal')
    // },
  }

  // flatFolders(){
  //   /*
  //   Create a flat list of available folders to be used when moving a project to a folder.
  //    */
  //   const folders = [];
  //   const visited = [];
  //
  //   const dfs_folder = function(folder, prefix=""){
  //     visited.push(folder.id);
  //     console.log("Visited", folder.id, folder.name);
  //
  //     folders.push({value: folder.id, text: prefix + folder.name});
  //
  //     if (folder.children.length > 0){
  //       folder.children.map(c => {
  //         if (!visited.includes(c.id)){
  //           dfs_folder(c, prefix + '-')
  //         }
  //       })
  //     }
  //   };
  //   dfs_folder(this.folderTree, "");
  //   return folders
  // }

  // activateFolder(folder: string){
  // Method used by RecursiveFolder to set active folder
  //   this.userSelectedFolder = folder;
  // },
  // activateFolderAfterDelete(folderId){
  //   console.log("Folder delete event:", folderId);
  //
  //   // DFS for the chosen folder
  //   const visited = [];
  //   const dfs_folder = function(folder){
  //     visited.push(folder.id);
  //     if (folder.children.length > 0){
  //       if (folder.id === folderId){
  //         return folder
  //       }
  //       folder.children.map(c => {
  //         if (!visited.includes(c.id)){
  //           dfs_folder(c)
  //         }
  //       })
  //     }
  //   };
  //
  //   this.userSelectedFolder = dfs_folder(this.folderTree);
  // },
  createNewFolder() {
    console.log('Creating new folder');
    // store.dispatch('rx/saveFolder', {
    //   parentId: this.activeFolder.id,
    //   folderName: this.newFolderName
    // }).then(() =>{
    //   this.getFolders()
    // });
  }

  getFolders() {
    console.log('Retreiving folders');
    // return store.dispatch('rx/getFolders')
  }

  // Lifecycle Hooks
  beforeMount(): void {
    if (userStore.userIsLoggedIn) {
      projectStore.loadAvailableProjects().then((projects) => this.availableProjects = projects);
    }
  }
}
